import { Mail, Clock, CheckCircle } from 'lucide-react';

interface AcknowledgedStepProps {
  message?: string;
}

export default function AcknowledgedStep({ message }: AcknowledgedStepProps) {
  return (
    <div className="text-center py-8">
      <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-accent-500/20 mb-6">
        <Mail className="w-10 h-10 text-accent-400" />
      </div>

      <h2 className="text-2xl font-bold text-white">
        Thanks for reaching out!
      </h2>

      <p className="text-slate-300 mt-3 max-w-md mx-auto">
        {message ||
          'Our team will review your request and get back to you soon.'}
      </p>

      <div className="mt-8 p-4 bg-slate-800 rounded-lg inline-flex items-center gap-3 border border-slate-700">
        <Clock className="w-5 h-5 text-slate-400" />
        <span className="text-sm text-slate-300">
          We typically respond within 1-2 business days
        </span>
      </div>

      <div className="mt-8 pt-6 border-t border-slate-700/50">
        <h3 className="text-sm font-medium text-white mb-3">What happens next?</h3>
        <div className="space-y-3 text-left max-w-sm mx-auto">
          <div className="flex items-start gap-3">
            <CheckCircle className="w-4 h-4 text-emerald-400 mt-0.5" />
            <span className="text-sm text-slate-300">
              Our team reviews your project details
            </span>
          </div>
          <div className="flex items-start gap-3">
            <CheckCircle className="w-4 h-4 text-emerald-400 mt-0.5" />
            <span className="text-sm text-slate-300">
              We'll reach out to schedule an intro call
            </span>
          </div>
          <div className="flex items-start gap-3">
            <CheckCircle className="w-4 h-4 text-emerald-400 mt-0.5" />
            <span className="text-sm text-slate-300">
              You'll receive a confirmation email shortly
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
